import { Link } from "react-router-dom";
import { useState } from "react";

const BlogGridInner = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 6;

  const blogPosts = [
    {
      id: 1,
      title: "Tips Memilih Les Privat yang Tepat untuk Anak",
      excerpt: "Panduan lengkap bagi orang tua dalam memilih bimbingan belajar yang sesuai dengan kebutuhan dan kemampuan anak",
      image: "assets/images/blog/tips-les-privat.jpg",
      date: "10 Mei 2025",
      author: "Tim Bimbel Kusuma",
      views: "856",
      category: "Panduan Orang Tua"
    },
    {
      id: 2, 
      title: "Cara Efektif Belajar Matematika SMP dari Rumah",
      excerpt: "Metode dan strategi belajar matematika yang efektif untuk siswa SMP dengan sistem belajar dari rumah",
      image: "assets/images/blog/belajar-matematika.jpg",
      date: "8 Mei 2025",
      author: "Tim Bimbel Kusuma",
      views: "743",
      category: "Tips Belajar"
    },
    {
      id: 3,
      title: "Persiapan Menghadapi Ujian Nasional untuk Siswa SMA",
      excerpt: "Strategi jitu mempersiapkan Ujian Nasional bagi siswa SMA/SMK dengan pendampingan guru professional",
      image: "assets/images/blog/persiapan-un.jpg",
      date: "5 Mei 2025",
      author: "Tim Bimbel Kusuma",
      views: "921",
      category: "Tips Ujian"
    },
    {
      id: 4,
      title: "Manfaat Les Privat untuk Perkembangan Anak",
      excerpt: "Penjelasan lengkap tentang dampak positif les privat terhadap perkembangan akademik dan kepribadian anak",
      image: "assets/images/blog/manfaat-les.jpg",
      date: "3 Mei 2025",
      author: "Tim Bimbel Kusuma",
      views: "678",
      category: "Panduan Orang Tua"
    },
    {
      id: 5,
      title: "Cara Meningkatkan Kemampuan Bahasa Inggris",
      excerpt: "Tips dan trik praktis untuk meningkatkan kemampuan berbahasa Inggris melalui program les privat",
      image: "assets/images/blog/tips-english.jpg",
      date: "1 Mei 2025",
      author: "Tim Bimbel Kusuma",
      views: "534",
      category: "Tips Belajar"
    },
    {
      id: 6,
      title: "Persiapan Masuk SMP: Apa Yang Harus Diperhatikan",
      excerpt: "Panduan lengkap mempersiapkan anak menghadapi transisi dari SD ke SMP dengan program les privat",
      image: "assets/images/blog/persiapan-smp.jpg",
      date: "28 April 2025",
      author: "Tim Bimbel Kusuma",
      views: "823",
      category: "Panduan Orang Tua"
    },
    {
      id: 7,
      title: "Tips Belajar IPA untuk Siswa SMP",
      excerpt: "Strategi efektif mempelajari mata pelajaran IPA untuk siswa SMP dengan metode yang menyenangkan",
      image: "assets/images/blog/tips-ipa.jpg",
      date: "25 April 2025",
      author: "Tim Bimbel Kusuma",
      views: "645",
      category: "Tips Belajar"
    },
    {
      id: 8,
      title: "Sukses UTBK dengan Les Privat",
      excerpt: "Strategi dan tips sukses menghadapi UTBK dengan bantuan program les privat yang tepat",
      image: "assets/images/blog/sukses-utbk.jpg",
      date: "22 April 2025",
      author: "Tim Bimbel Kusuma",
      views: "912",
      category: "Tips Ujian"
    },
    {
      id: 9,
      title: "Program Les TK/PAUD: Membangun Fondasi Belajar",
      excerpt: "Pentingnya membangun dasar pembelajaran yang kuat sejak usia dini melalui program les privat TK/PAUD",
      image: "assets/images/blog/program-tk.jpg",
      date: "20 April 2025",
      author: "Tim Bimbel Kusuma",
      views: "567",
      category: "Panduan Orang Tua"
    }
  ];

  // Pagination logic
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = blogPosts.slice(indexOfFirstPost, indexOfLastPost);
  const totalPages = Math.ceil(blogPosts.length / postsPerPage);

  const paginate = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
      window.scrollTo(0, 0);
    }
  };

  return (
    <div className='blog-page-section py-120'>
      <div className='container'>
        <div className='flex-between gap-16 flex-wrap mb-40'>
          <span className='text-neutral-500'>Artikel Terbaru Bimbel Kusuma</span>
          <div className='flex-align gap-16'>
            <div className='flex-align gap-8'>
              <span className='text-neutral-500 flex-shrink-0'>Urutkan :</span>
              <select className='form-select ps-20 pe-28 py-8 fw-medium rounded-pill bg-main-25 border border-neutral-30 text-neutral-700'>
                <option value="terbaru">Terbaru</option>
                <option value="populer">Terpopuler</option>
                <option value="kategori">Kategori</option>
              </select>
            </div>
          </div>
        </div>

        <div className='row gy-4'>
          {currentPosts.map((post) => (
            <div key={post.id} className='col-lg-4 col-sm-6'>
              <article className='scale-hover-item bg-main-25 rounded-16 p-12 h-100 border border-neutral-30'>
                <div className='course-item__thumb rounded-12 overflow-hidden position-relative'>
                  <Link to={`/blog/${post.id}`} className='w-100 h-100'>
                    <img
                      src={post.image}
                      alt={post.title}
                      className='scale-hover-item__img rounded-12 cover-img transition-2'
                    />
                  </Link>
                  <div className='position-absolute inset-inline-end-0 inset-block-end-0 me-16 mb-16 py-12 px-24 rounded-8 bg-main-three-600 text-white fw-medium'>
                    <span className='mb-0 text-white fw-medium'>{post.date}</span>
                  </div>
                </div>
                <div className='pt-32 pb-24 px-16 position-relative'>
                  <h4 className='mb-28'>
                    <Link to={`/blog/${post.id}`} className='link text-line-2'>
                      {post.title}
                    </Link>
                  </h4>
                  <p className='text-neutral-500 text-line-2 mb-20'>
                    {post.excerpt}
                  </p>
                  <div className='flex-align gap-14 flex-wrap my-20'>
                    <div className='flex-align gap-8'>
                      <span className='text-neutral-500 text-2xl d-flex'>
                        <i className='ph ph-user-circle' />
                      </span>
                      <span className='text-neutral-500 text-lg'>
                        {post.author}
                      </span>
                    </div>
                    <span className='w-8 h-8 bg-neutral-100 rounded-circle' />
                    <div className='flex-align gap-8'>
                      <span className='text-neutral-500 text-2xl d-flex'>
                        <i className='ph-bold ph-tag' />
                      </span>
                      <span className='text-neutral-500 text-lg'>
                        {post.category}
                      </span>
                    </div>
                    <span className='w-8 h-8 bg-neutral-100 rounded-circle' />
                    <div className='flex-align gap-8'>
                      <span className='text-neutral-500 text-2xl d-flex'>
                        <i className='ph-bold ph-eye' />
                      </span>
                      <span className='text-neutral-500 text-lg'>{post.views}</span>
                    </div>
                  </div>
                  <div className='flex-between gap-8 pt-24 border-top border-neutral-50 mt-28 border-dashed border-0'>
                    <Link
                      to={`/blog/${post.id}`}
                      className='flex-align gap-8 text-main-600 hover-text-decoration-underline transition-1 fw-semibold'
                      aria-label={`Baca selengkapnya tentang ${post.title}`}
                    >
                      Baca Selengkapnya
                      <i className='ph ph-arrow-right' />
                    </Link>
                  </div>
                </div>
              </article>
            </div>
          ))}
        </div>

        <ul className='pagination mt-40 flex-align gap-12 flex-wrap justify-content-center'>
          <li className='page-item'>
            <button
              className='page-link text-neutral-700 fw-semibold w-40 h-40 bg-main-25 rounded-circle hover-bg-main-600 border-neutral-30 hover-border-main-600 hover-text-white flex-center p-0'
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
            >
              <i className='ph-bold ph-caret-left' />
            </button>
          </li>
          
          {[...Array(totalPages)].map((_, index) => (
            <li key={index} className='page-item'>
              <button
                className={`page-link text-neutral-700 fw-semibold w-40 h-40 rounded-circle border-neutral-30 hover-border-main-600 hover-text-white flex-center p-0 ${
                  currentPage === index + 1 ? 'bg-main-600 text-white' : 'bg-main-25'
                }`}
                onClick={() => paginate(index + 1)}
              >
                {index + 1}
              </button>
            </li>
          ))}

          <li className='page-item'>
            <button
              className='page-link text-neutral-700 fw-semibold w-40 h-40 bg-main-25 rounded-circle hover-bg-main-600 border-neutral-30 hover-border-main-600 hover-text-white flex-center p-0'
              onClick={() => paginate(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              <i className='ph-bold ph-caret-right' />
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default BlogGridInner;
